// contexts/UserPreferencesContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from './AuthContext';

const UserPreferencesContext = createContext(null);

export function useUserPreferences() {
  return useContext(UserPreferencesContext);
}

export function UserPreferencesProvider({ children }) {
  const { user } = useAuth();
  const [preferences, setPreferences] = useState(null);

  useEffect(() => {
    const loadPreferences = async () => {
      if (!user) {
        setPreferences(null);
        return;
      }
      try {
        const { data, error } = await supabase
          .from('user_preferences')
          .select('*')
          .eq('id', user.id)
          .single();
        if (!error && data) {
          setPreferences(data);
        }
      } catch (err) {
        console.error('Error loading user preferences:', err);
      }
    };
    loadPreferences();
  }, [user]);

  return (
    <UserPreferencesContext.Provider value={{ preferences }}>
      {children}
    </UserPreferencesContext.Provider>
  );
}
